import BigNumber from 'bignumber.js';
import { useDispatch, useSelector } from 'react-redux'
import {
    chainId, feeV3, gas, gasLimit, isAdvanced, permit2, pool, router, spenToken, token, universalRouter,
    v3Factory, vip, swapType,
    rpc,
    currentGas,
} from '@/store'
import { useEffect, useRef, useState } from 'react'
import { ERC20ABI, FEE_ADDRESS, NOVIP_AMOUNT, SwapABI, V3FactoryContract, Flap, poolManagerABI, RPCLIST, zeroAddress } from '@/config'
import { getTime } from '@/utils/bot'
import { AllowanceTransfer, PermitSingle } from '@uniswap/permit2-sdk'
import { isPaidNode } from '@/views/MarKetBot/MarketBotLeft/Header'
import { useProviderInstance } from '@/context/ProviderContext'
import { concat, encodeAbiParameters, encodeFunctionData, encodePacked, getAddress, getContract, Hex, http, maxUint256, parseAbiParameters, parseEther, parseUnits } from 'viem';
import { checkAddress } from '@/utils/toHex';


export function useExecuteSwapWithFee() {
    const _feeV3 = useSelector(feeV3)
    const _universalRouter = useSelector(universalRouter)
    const _permit2 = useSelector(permit2)
    const _chainId = useSelector(chainId)
    const _rpc = useSelector(rpc)
    const _currentGas = useSelector(currentGas)
    const _gas = useSelector(gas)
    const _vip = useSelector(vip)
    const _gasLimit = useSelector(gasLimit)
    const [currentGasLimit, setCurrentGasLimit] = useState<string | null>("1500000");
    const [currentGasPrice, setCurrentGasPrice] = useState<string | null>();
    const _V3Factory = useSelector(v3Factory)

    const provider = useProviderInstance()

    const _isAdvanced = useSelector(isAdvanced)


    useEffect(() => {
        if (_gasLimit && _isAdvanced) {
            setCurrentGasLimit(_gasLimit)
        }
        else {
            setCurrentGasLimit("1500000")
        }
        if (_gas && _isAdvanced) {
            setCurrentGasPrice(parseUnits(_gas, 9).toString()); // 9 表示 gwei 的精度
        } else {
            setCurrentGasPrice(_currentGas.toString())
        }
    }, [_gas, _gasLimit, _currentGas])
    const rpcsArrayNew = RPCLIST.find((items) => items.id === _chainId).rpcs;

    const boolean = rpcsArrayNew[0] === _rpc && isPaidNode(_rpc);

    const chargeNode = boolean
        ? parseEther(NOVIP_AMOUNT[_chainId]) / BigInt(10)
        : parseEther('0');
    const FEE_AMOUNT = parseEther(NOVIP_AMOUNT[_chainId])
    const routerAbi = [
        {
            "inputs": [
                {
                    "internalType": "bytes",
                    "name": "commands",
                    "type": "bytes"
                },
                {
                    "internalType": "bytes[]",
                    "name": "inputs",
                    "type": "bytes[]"
                },
                {
                    "internalType": "uint256",
                    "name": "deadline",
                    "type": "uint256"
                }
            ],
            "name": "execute",
            "outputs": [],
            "stateMutability": "payable",
            "type": "function"
        }
    ] as const;
    // ✅ 正确格式 - 标准 ABI 对象
    const permit2Abi = [
        {
            inputs: [
                { name: 'owner', type: 'address' },
                { name: 'token', type: 'address' },
                { name: 'spender', type: 'address' }
            ],
            name: 'allowance',
            outputs: [
                { name: 'amount', type: 'uint160' },
                { name: 'expiration', type: 'uint48' },
                { name: 'nonce', type: 'uint48' }
            ],
            stateMutability: 'view',
            type: 'function'
        },
    ] as const

    const _router = useSelector(router)
    const _token = useSelector(token)
    const _spenToken = useSelector(spenToken)
    const _swapType = useSelector(swapType)
    interface SwapParams {
        wallet: any
        publicClient: any            // 必填
        isBuy: boolean               // 买 or 卖
        poolKeyArray: any[]
        needsApproval: boolean //是否需要授权，不用每次交易都检查一遍了

        path?: string[]      // V2: address[]，V3: bytes

        amountIn?: bigint  // 主要用于 v2/v3
        amountOutMin?: bigint// 最小输出

        // Four Meme 专用
        spendAmount?: bigint
        sellAmount?: bigint

        // 统一字段
        value?: bigint     // 原生代币 value
        isSpenMianToken?: boolean   // 是否主币支付
        // isV3?: boolean               // v3 or v2
    }

    const executeSwapWithFee = async (params: SwapParams) => {
        const {
            wallet,
            publicClient,
            path,
            value = 0n,
            isSpenMianToken = false,
            isBuy,
            amountIn,
            amountOutMin,

            // four 专用，可不传
            spendAmount,
            sellAmount,
            poolKeyArray,
            needsApproval
            // v2/v3 控制，可不传
            // isV3 = false,
        } = params;
        // -------------------------- 2. 核心交易函数 --------------------------
        // -------------------------- 2. 核心交易函数 --------------------------

        // console.log(' amountIn,::: ', Number(amountIn), Number(amountOutMin),);


        // -------------------------- 3. 前端调用示例（MetaMask + ethers v5） --------------------------
        // const handleV4 = async () => {
        //     /****************************************
        //          * 🔥 Universal Router V2/V3
        //      ****************************************/

        //     const MAX_ALLOWANCE = BigInt("1461501637330902918203684832716283019655932542975")
        //     const BIG_ALLOWANCE_CHECK = BigInt("5192296858534827628530496329220095")
        //     let commands, inputs;
        //     const deadline = Math.floor(Date.now() / 1000) + 1800;   // 30m
        //     const expiration = deadline + 86400;                     // 24h
        //     const approveToken = Array.isArray(path) ? path[0] : null;

        //     // console.log('amountIn::: ', amountIn);

        //     const Methods = poolKeyArray[0] == _spenToken.address
        //     // console.log('poolKeyArray[0]::: ', poolKeyArray[0]);
        //     // console.log('Methods::: ', Methods);
        //     const swapMethods = Methods ? isBuy : !isBuy;
        //     // console.log('swapMethods::: ', swapMethods);
        //     // console.log('path::: ', path);
        //     const swapParams = ethers.utils.defaultAbiCoder.encode(
        //         [
        //             'tuple(' +
        //             'tuple(address currency0, address currency1, address hooks, address poolManager, uint24 fee, bytes32 parameters),' +
        //             'bool,' +
        //             'uint128,' +
        //             'uint128,' +
        //             'bytes' +
        //             ')'
        //         ],
        //         [[poolKeyArray, swapMethods, amountIn, amountOutMin, "0x"]]
        //     );

        //     const settleAll = ethers.utils.defaultAbiCoder.encode(
        //         ['address', 'uint256'],
        //         [path[0], amountIn]);

        //     const takeAll = ethers.utils.defaultAbiCoder.encode(
        //         ['address', 'uint256'],
        //         [path[1], amountOutMin]);

        //     const actionInputs = [swapParams, settleAll, takeAll];
        //     const actions = ethers.utils.hexConcat(['0x06', '0x0c', '0x0f']);



        //     console.log('isSpenMianToken::: ', isSpenMianToken);

        //     /****************************************
        //      * 情况 1：主币支付 + 买
        //      ****************************************/
        //     if (isSpenMianToken && isBuy) {
        //         commands = ethers.utils.hexConcat([
        //             // "0x0b",               // wrap native token
        //             "0x10",
        //         ]);

        //         inputs = [
        //             // wrap
        //             // ethers.utils.defaultAbiCoder.encode(
        //             //     ["address", "uint256"],
        //             //     [_universalRouter, value]
        //             // ),
        //             ethers.utils.defaultAbiCoder.encode(
        //                 ['bytes', 'bytes[]'],
        //                 [actions, actionInputs] // recipient, actions, inputs, limit
        //             )
        //         ];
        //     }

        //     /****************************************
        //      * 情况 2：主币支付 + 卖
        //      ****************************************/
        //     else if (isSpenMianToken && !isBuy) {
        //         await tokenApproveHandler(wallet, _permit2, approveToken, ethers.constants.MaxUint256.div(2).toString());

        //         const { permitSingle, signature, allowanceTuple } =
        //             await getPermitSignature(wallet, approveToken, MAX_ALLOWANCE, expiration, _chainId);
        //         console.log('permitSingle::: ', 'permitSingle');

        //         const [allowanceAmount, allowTime] = allowanceTuple;
        //         const now = Math.floor(Date.now() / 1000);
        //         const need0a = !(allowTime > now && allowanceAmount > BIG_ALLOWANCE_CHECK);//需不需要授权

        //         commands = ethers.utils.hexConcat([
        //             ...(need0a ? ["0x0a"] : []),
        //             "0x10",
        //             "0x0c",
        //         ]);

        //         inputs = [
        //             ...(need0a
        //                 ?
        //                 [
        //                     ethers.utils.defaultAbiCoder.encode(
        //                         ["tuple(tuple(address,uint160,uint48,uint48),address,uint256)", "bytes"],
        //                         [[
        //                             [
        //                                 permitSingle.details.token,
        //                                 permitSingle.details.amount,
        //                                 permitSingle.details.expiration,
        //                                 permitSingle.details.nonce,
        //                             ],
        //                             permitSingle.spender,
        //                             permitSingle.sigDeadline,
        //                         ], signature]
        //                     ),
        //                 ]
        //                 : []),

        //             // swap
        //             // ethers.utils.defaultAbiCoder.encode(
        //             //     ["address", "uint256", "uint256", isV3 ? "bytes" : "address[]", "bool"],
        //             //     [_universalRouter, amountIn, amountOutMin, swapPath, true]
        //             // ),
        //             ethers.utils.defaultAbiCoder.encode(
        //                 ['bytes', 'bytes[]'],
        //                 [actions, actionInputs] // recipient, actions, inputs, limit
        //             ),
        //             // unwrap
        //             ethers.utils.defaultAbiCoder.encode(
        //                 ["address", "uint256"],
        //                 [wallet.address, 0]
        //             ),

        //         ];
        //     }

        //     /****************************************
        //      * 情况 3：普通 token 支付（v2/v3）
        //      ****************************************/
        //     else {
        //         // await tokenApproveHandler(wallet, _permit2, approveToken, ethers.constants.MaxUint256.div(2).toString());
        //         // console.log(Number(amountIn), BigInt(amountIn.toString()), 'amountIn');
        //         const { permitSingle, signature, allowanceTuple } = await getPermitSignature(wallet, approveToken, MAX_ALLOWANCE, expiration, _chainId);
        //         console.log('permitSingle, signature, allowanceTuple::: ', permitSingle, signature, allowanceTuple);
        //         // 构建命令
        //         const time = allowanceTuple[1]
        //         const now = Math.floor(Date.now() / 1000)   // 当前时间戳（秒）
        //         const need0a = !(time > now && allowanceTuple[0] > BIG_ALLOWANCE_CHECK);
        //         commands = ethers.utils.hexConcat([
        //             ...(need0a ? ['0x0a'] : []), ,
        //             "0x10" // swap 指令执行
        //         ]);

        //         // 构建inputs参数
        //         inputs = [
        //             ...(need0a ? [
        //                 ethers.utils.defaultAbiCoder.encode(
        //                     ['tuple(tuple(address,uint160,uint48,uint48),address,uint256)', 'bytes'],
        //                     [[[
        //                         permitSingle.details.token,
        //                         permitSingle.details.amount,
        //                         permitSingle.details.expiration,
        //                         permitSingle.details.nonce
        //                     ], permitSingle.spender, permitSingle.sigDeadline], signature]
        //                 )
        //             ] : []),


        //             ethers.utils.defaultAbiCoder.encode(
        //                 ['bytes', 'bytes[]'],
        //                 [actions, actionInputs] // recipient, actions, inputs, limit
        //             )



        //         ]

        //         console.log('actionInputs::: ', actions);

        //         console.log(actionInputs, 'actionInputs');

        //     }

        //     /****************************************
        //      * 手续费
        //      ****************************************/
        //     if (!_vip) {
        //         commands = ethers.utils.hexConcat([commands, "0x05"]);
        //         inputs.push(
        //             ethers.utils.defaultAbiCoder.encode(
        //                 ["address", "address", "uint256"],
        //                 ["0x0000000000000000000000000000000000000000", FEE_ADDRESS, FEE_AMOUNT]
        //             )
        //         );
        //     } else {
        //         commands = ethers.utils.hexConcat([commands, "0x05"]);
        //         inputs.push(
        //             ethers.utils.defaultAbiCoder.encode(
        //                 ["address", "address", "uint256"],
        //                 ["0x0000000000000000000000000000000000000000", FEE_ADDRESS, chargeNode]
        //             )
        //         );
        //     }
        //     // console.log(currentGasLimit, 'currentGasLimit');
        //     const router = new ethers.Contract(_universalRouter, routerAbi, wallet);
        //     console.log('router::: ', router);

        //     return await router.execute(commands, inputs, deadline, {
        //         value: _vip ? value.add(chargeNode) : value.add(FEE_AMOUNT),
        //         ...(currentGasLimit ? { gasLimit: currentGasLimit } : {}),
        //         ...(currentGasPrice ? { gasPrice: currentGasPrice } : {}),
        //     });
        // }



        try {
            const data = _router.label

            const isV3 = data.includes("V3")
            // console.log(isV3, 'isV3');
            const handle = async () => {
                /****************************************
                     * 🔥 Universal Router V2/V3
                 ****************************************/
                const MAX_ALLOWANCE = BigInt("1461501637330902918203684832716283019655932542975")
                const BIG_ALLOWANCE_CHECK = BigInt("5192296858534827628530496329220095")
                let commands
                const inputs: `0x${string}`[] = [];
                const deadline = Math.floor(Date.now() / 1000) + 1800;   // 30m
                const expiration = deadline + 86400;                     // 24h
                const approveToken = Array.isArray(path) ? path[0] : null;

                let swapPath = path;

                // v3 path 编码
                if (isV3) {
                    const fee = Number(_feeV3) * 10000;
                    swapPath = await getPathBytes(path, fee.toString(), isBuy);
                }
                console.log('isSpenMianToken && !isBuy::: ', isSpenMianToken, isBuy);

                /****************************************
                 * 情况 1：主币支付 + 买
                 ****************************************/
                if (isSpenMianToken && isBuy) {
                    // 构建 commands
                    const commandParts: `0x${string}`[] = [
                        '0x0b', // 0x0b把用户发送进来的原生 BNB 包装成 WBNB。
                        isV3 ? '0x00' : '0x08' //0x08 = V2_SWAP_EXACT_IN 0x00 = V3_SWAP_EXACT_IN
                    ];
                    commands = concat(commandParts);

                    // 构建 inputs
                    // wrap 参数编码
                    const wrapEncoded = encodeAbiParameters(
                        [
                            { name: 'recipient', type: 'address' },
                            { name: 'amount', type: 'uint256' }
                        ],
                        [checkAddress(_universalRouter, 'UniversalRouter（交易所配置）'), BigInt(value.toString())]
                    );
                    inputs.push(wrapEncoded);

                    // swap 参数编码
                    let swapAbi = isV3 ? 'address,uint256,uint256,bytes,bool' : 'address,uint256,uint256,address[],bool';
                    if (_chainId === 4663 || _chainId === 5042) {
                        swapAbi += ',uint256[]';
                    }

                    const swapParams: any[] = [
                        wallet.account.address,
                        BigInt(value.toString()),
                        amountOutMin,
                        swapPath,
                        false
                    ];

                    // chainId 4663 特殊处理
                    if (_chainId === 4663 || _chainId === 5042) {
                        swapParams.push([]);
                    }

                    const swapEncoded = encodeAbiParameters(
                        parseAbiParameters(swapAbi),
                        swapParams as any
                    );
                    inputs.push(swapEncoded);
                }

                /****************************************
                 * 情况 2：主币支付 + 卖
                 ****************************************/
                else if (isSpenMianToken && !isBuy) {
                    console.log('needsApproval::: ', needsApproval);

                    if (needsApproval) {
                        // Permit2 相当于一个中间的授权管理器，Universal Router 不直接依赖 ERC20 的普通 approve
                        // 第一层 approve 是：Token → Permit2。
                        await tokenApproveHandler(wallet, _permit2, approveToken, publicClient);

                    }

                    // 第二层 Permit2 允许 Universal Router 按照这份签名使用我的 Token。
                    const { permitSingle, signature, allowanceTuple } = await getPermitSignature(wallet, approveToken, MAX_ALLOWANCE, expiration, _chainId, publicClient);

                    const [allowanceAmount, allowTime] = allowanceTuple;
                    const now = Math.floor(Date.now() / 1000);
                    const need0a = !(allowTime > now && allowanceAmount > BIG_ALLOWANCE_CHECK);

                    const commandParts: `0x${string}`[] = [];
                    if (need0a) {
                        // 0x0a Permit2 授权 → Universal Router 使用
                        commandParts.push('0x0a');
                    }
                    commandParts.push(isV3 ? '0x00' : '0x08');
                    // 0x0c：WBNB → BNB命令
                    commandParts.push('0x0c');
                    commands = concat(commandParts);
                    // permit 参数编码 (0x0a)
                    if (need0a) {
                        const permitEncoded = encodeAbiParameters(
                            [
                                {
                                    components: [
                                        {
                                            components: [
                                                { name: 'token', type: 'address' },
                                                { name: 'amount', type: 'uint160' },
                                                { name: 'expiration', type: 'uint48' },
                                                { name: 'nonce', type: 'uint48' }
                                            ],
                                            name: 'details',
                                            type: 'tuple'
                                        },
                                        { name: 'spender', type: 'address' },
                                        { name: 'sigDeadline', type: 'uint256' }
                                    ],
                                    name: 'permit',
                                    type: 'tuple'
                                },
                                { name: 'signature', type: 'bytes' }
                            ],
                            [
                                {
                                    details: {
                                        token: permitSingle.details.token as `0x${string}`,
                                        amount: BigInt(permitSingle.details.amount.toString()),
                                        expiration: Number(permitSingle.details.expiration.toString()),
                                        nonce: Number(permitSingle.details.nonce.toString())
                                    },
                                    spender: permitSingle.spender as `0x${string}`,
                                    sigDeadline: BigInt(permitSingle.sigDeadline.toString())
                                },
                                signature as `0x${string}`
                            ]
                        );
                        inputs.push(permitEncoded);
                    }

                    // swap 参数编码 (0x00 或 0x08)
                    let swapAbi = isV3 ? 'address,uint256,uint256,bytes,bool' : 'address,uint256,uint256,address[],bool';
                    if (_chainId === 4663 || _chainId === 5042) {
                        swapAbi += ',uint256[]';
                    }

                    const swapArgs: any[] = [
                        _universalRouter as `0x${string}`,
                        amountIn,
                        amountOutMin,
                        swapPath,
                        true
                    ];
                    if (_chainId === 4663 || _chainId === 5042) {
                        swapArgs.push([]);
                    }

                    const swapEncoded = encodeAbiParameters(
                        parseAbiParameters(swapAbi),
                        swapArgs
                    );
                    inputs.push(swapEncoded);

                    // unwrap 参数编码 (0x0c)
                    const unwrapEncoded = encodeAbiParameters(
                        parseAbiParameters('address, uint256'),
                        [wallet.account.address as `0x${string}`, BigInt(0)]
                    );
                    inputs.push(unwrapEncoded);

                }

                /****************************************
                 * 情况 3：普通 token 支付（v2/v3）
                 ****************************************/
                else {

                    if (needsApproval) { await tokenApproveHandler(wallet, _permit2, approveToken, publicClient); }
                    const { permitSingle, signature, allowanceTuple } = await getPermitSignature(wallet, approveToken, MAX_ALLOWANCE, expiration, _chainId, publicClient);
                    // 构建命令
                    const time = allowanceTuple[1]
                    const now = Math.floor(Date.now() / 1000)   // 当前时间戳（秒）
                    const need0a = !(time > now && allowanceTuple[0] > BIG_ALLOWANCE_CHECK);
                    console.log('need0a::: ', need0a);
                    const commandParts: `0x${string}`[] = [];
                    if (need0a) {
                        commandParts.push('0x0a');
                    }
                    commandParts.push(isV3 ? '0x00' : '0x08');
                    commands = concat(commandParts);


                    if (need0a) {
                        // 直接编码整个 permit 数据
                        const permitEncoded = encodeAbiParameters(
                            [
                                {
                                    components: [
                                        {
                                            components: [
                                                { name: 'token', type: 'address' },
                                                { name: 'amount', type: 'uint160' },
                                                { name: 'expiration', type: 'uint48' },
                                                { name: 'nonce', type: 'uint48' }
                                            ],
                                            name: 'details',
                                            type: 'tuple'
                                        },
                                        { name: 'spender', type: 'address' },
                                        { name: 'sigDeadline', type: 'uint256' }
                                    ],
                                    name: 'permit',
                                    type: 'tuple'
                                },
                                { name: 'signature', type: 'bytes' }
                            ],
                            [
                                {
                                    details: {
                                        token: permitSingle.details.token as `0x${string}`,
                                        amount: BigInt(permitSingle.details.amount.toString()), // uint160 -> number
                                        expiration: Number(permitSingle.details.expiration.toString()), // uint48 -> number
                                        nonce: Number(permitSingle.details.nonce.toString()) // uint48 -> number
                                    },
                                    spender: permitSingle.spender as `0x${string}`,
                                    sigDeadline: BigInt(permitSingle.sigDeadline.toString()) // uint256 -> bigint
                                },
                                signature as `0x${string}`
                            ]
                        );
                        inputs.push(permitEncoded);
                    }
                    // swap 参数
                    let swapAbi = isV3 ? 'address,uint256,uint256,bytes,bool' : 'address,uint256,uint256,address[],bool';
                    if (_chainId === 4663 || _chainId === 5042) {
                        swapAbi += ',uint256[]';
                    }
                    console.log('amountOutMin.toString()::: ', amountOutMin.toString());
                    const swapArgs: any[] = [
                        wallet.account.address,
                        amountIn,
                        amountOutMin,
                        isV3 ? swapPath : path,
                        true
                    ];
                    if (_chainId === 4663 || _chainId === 5042) {
                        swapArgs.push([]);
                    }

                    const swapEncoded = encodeAbiParameters(
                        parseAbiParameters(swapAbi),
                        swapArgs
                    );
                    inputs.push(swapEncoded);

                }

                /****************************************
                 * 手续费
                 ****************************************/
                // 0x05 手续费命令
                if (!_vip) {
                    commands = concat([commands, '0x05']);
                    const feeEncoded = encodeAbiParameters(
                        parseAbiParameters('address, address, uint256'),
                        [
                            '0x0000000000000000000000000000000000000000' as `0x${string}`,
                            FEE_ADDRESS as `0x${string}`,
                            BigInt(FEE_AMOUNT.toString())
                        ]
                    );
                    inputs.push(feeEncoded);
                } else {
                    commands = concat([commands, '0x05']);
                    const feeEncoded = encodeAbiParameters(
                        parseAbiParameters('address, address, uint256'),
                        [
                            '0x0000000000000000000000000000000000000000' as `0x${string}`,
                            FEE_ADDRESS as `0x${string}`,
                            BigInt(chargeNode.toString())
                        ]
                    );
                    inputs.push(feeEncoded);
                }

                console.log('commands, inputs::: ', commands, inputs);

                const executeData = encodeFunctionData({
                    abi: routerAbi, // 需要确保 routerAbi 是 viem 格式的 ABI
                    functionName: 'execute',
                    args: [commands, inputs, BigInt(deadline)]
                });

                // 计算交易 value
                const txValue = _vip ? value + chargeNode : value + FEE_AMOUNT;


                const txRequest = {
                    to: _universalRouter,
                    data: executeData,
                    value: BigInt(txValue.toString()),
                    chainId: _chainId,
                    ...(currentGasLimit ? { gas: BigInt(currentGasLimit) } : {}),
                    ...(currentGasPrice ? { gasPrice: BigInt(currentGasPrice) } : {}),
                };

                // 使用 walletClient 发送交易
                const txResponse = await wallet.sendTransaction({
                    ...txRequest,
                    account: wallet.account
                });

                return txResponse;
            }
            let res: any
            switch (_swapType) {
                case 'V3':
                case 'V2':
                    res = await handle()
                    break;
                case 'four':


                    /****************************************
                     * 🔥 Four Meme 模式
                     ****************************************/

                    const method = isBuy ? "buyTokenAMAP" : "sellToken";
                    const feeVal = _vip ? chargeNode : FEE_AMOUNT;

                    if (isBuy && !isSpenMianToken) {
                        if (needsApproval) {
                            await tokenApproveHandler(wallet, _router.address, _spenToken?.address, publicClient);
                        }
                    }
                    let sellAmounts: bigint;
                    if (!isBuy) {
                        if (needsApproval) {
                            await tokenApproveHandler(wallet, _permit2, _token?.address, publicClient);
                        }
                        sellAmounts = truncateToThreeDecimalPlaces(sellAmount);
                    }

                    const callArgs = isBuy
                        ? [
                            _spenToken?.address as `0x${string}`,
                            _token?.address as `0x${string}`,
                            spendAmount,
                            amountOutMin,
                            feeVal,
                        ]
                        : [
                            0n,
                            _token?.address as `0x${string}`,
                            sellAmounts,
                            amountOutMin,
                            feeVal,
                        ]

                    // res = await Contract[method](...callParams);
                    res = await wallet.writeContract({
                        address: _router.address as `0x${string}`,
                        abi: SwapABI,
                        functionName: method,
                        args: callArgs,
                        value: value + feeVal,
                        ...(currentGasLimit ? { gas: BigInt(currentGasLimit) } : {}),
                        ...(currentGasPrice ? { gasPrice: BigInt(currentGasPrice) } : {}),
                    })
                    break;
                case 'flap': {
                    /****************************************
                     * 🔥 flap Meme 模式
                     ****************************************/
                    const method = "swapToken";
                    const feeVal = _vip ? chargeNode : FEE_AMOUNT;

                    if (isBuy && !isSpenMianToken) {
                        if (needsApproval) {
                            await tokenApproveHandler(wallet, _router.address, _spenToken?.address, publicClient);
                        }
                    }
                    if (!isBuy) {
                        if (needsApproval) {
                            // 卖出的 Meme 不直接授权给 Flap Router，而是先授权给Permit2，然后 Flap 的交易流程通过 Permit2 使用这个 Meme。
                            await tokenApproveHandler(wallet, _permit2, _token?.address, publicClient);
                        }
                    }
                    console.log(Number(spendAmount), Number(sellAmount), 'spendAmount');

                    const callArgs = isBuy
                        ? [
                            _spenToken?.address as `0x${string}`,
                            _token?.address as `0x${string}`,
                            spendAmount,
                            amountOutMin,
                            feeVal,
                        ]
                        : [
                            _token?.address as `0x${string}`,
                            _spenToken?.address as `0x${string}`,
                            sellAmount,
                            amountOutMin,
                            feeVal,
                        ];
                    res = await wallet.writeContract({
                        address: _router.address as `0x${string}`,
                        abi: Flap,
                        functionName: method,
                        args: callArgs,
                        value: value + feeVal,
                        ...(currentGasLimit ? { gas: BigInt(currentGasLimit) } : {}),
                        ...(currentGasPrice ? { gasPrice: BigInt(currentGasPrice) } : {}),
                    });


                }
                    break;
                case 'V4':
                    {
                        // res = await handleV4()
                    }
                    break;
                default:
                    res = await handle()
                    break;
            }
            return res
        } catch (err) {
            console.error("执行失败:", err);
            throw err;
        }
    };

    const getPathBytes = async (path: string[], fee: string, isBuy: boolean) => {
        let pathBytes;
        console.log('path.length::: ', path.length);

        if (path.length === 2) {
            pathBytes = encodePacked(
                ['address', 'uint24', 'address'],
                [path[0] as `0x${string}`, Number(fee), path[1] as `0x${string}`]
            );
        } else if (path.length === 3 && isBuy) {
            pathBytes = encodePacked(
                ['address', 'uint24', 'address', 'uint24', 'address'],
                [
                    path[0] as `0x${string}`,
                    await findExistingFeeTiers(path[0], path[1]),
                    path[1] as `0x${string}`,
                    Number(fee),
                    path[2] as `0x${string}`
                ]
            );
        } else if (path.length === 3 && !isBuy) {
            pathBytes = encodePacked(
                ['address', 'uint24', 'address', 'uint24', 'address'],
                [
                    path[0] as `0x${string}`,
                    Number(fee),
                    path[1] as `0x${string}`,
                    await findExistingFeeTiers(path[1], path[2]),
                    path[2] as `0x${string}`
                ]
            );
        }
        return pathBytes;
    };
    const findExistingFeeTiers = async (tokenA, tokenB) => {
        const feeTiers = [100, 500, 2500, 3000, 10000];

        const factory = getContract({
            address: checkAddress(_V3Factory, 'V3Factory'),
            abi: V3FactoryContract.abi,
            client: provider
        }) as any
        const existingFees = [];
        for (const fee of feeTiers) {
            try {
                const poolAddress = await factory.read.getPool(tokenA, tokenB, fee);
                if (poolAddress !== zeroAddress) {
                    existingFees.push(fee);
                }
            } catch (error) {
                console.error(`查询池子失败: ${tokenA} - ${tokenB} - ${fee}`);
            }
        }
        if (existingFees.length > 0) {
            return Math.min(...existingFees);
        } else {
            return null;
        }
    }


    const tokenApproveHandler = async (
        wallet: any,
        routerAddress: string,
        tokenAddress: string,
        publicClient: any
    ) => {
        // const max = BigNumber.from(ethers.utils.parseEther(_maxAmount))
        try {
            // const allowance = await publicClient.readContract({
            //     address: to0xString(tokenAddress),
            //     abi: ERC20ABI,
            //     functionName: 'allowance',
            //     args: [
            //         wallet.account.address,
            //         to0xString(routerAddress),
            //     ],
            // })
            // console.log('allowance > maxUint256 / 2n::: ', tokenAddress, allowance, allowance > maxUint256 / 2n);

            // if (allowance > maxUint256 / 2n) {
            //     return { status: true }
            // } else {

            const hash = await wallet.writeContract({
                address: checkAddress(tokenAddress, '代币地址'),
                abi: ERC20ABI,
                functionName: 'approve',
                args: [checkAddress(routerAddress, '授权目标地址'), maxUint256],
            })
            console.log('hash:3333', hash)


            // }
        } catch (err) {
            throw err
        }
    }


    async function getPermitSignature(
        wallet: any,
        INPUT_ADDRESS: string,
        amountIn: bigint,
        expiration: number,
        chainId: number,
        publicClient: any
    ) {

        const allowanceTuple = await publicClient.readContract({
            address: checkAddress(_permit2, 'Permit2'),
            abi: permit2Abi,
            functionName: 'allowance',
            args: [
                wallet.account.address,
                checkAddress(INPUT_ADDRESS, '代币地址'),
                checkAddress(_universalRouter, 'UniversalRouter（交易所配置）'),
            ],
        })
        console.log('allowanceTuple::: ', allowanceTuple);

        const onchainNonce = BigInt(allowanceTuple[2].toString());
        // 所以这份 Permit2 签名表达的是：
        // 我允许 Universal Router 使用我的 TOKEN，数量是 amountIn，并且有效期到 expiration。

        //1. 构建 PermitSingle 对象
        const permitSingle: PermitSingle = {
            details: {
                token: INPUT_ADDRESS,
                amount: amountIn,                  // uint160
                expiration,                        // uint48
                nonce: onchainNonce                // uint48，通常从链上查询
            },
            spender: _universalRouter,
            sigDeadline: expiration              // uint256
        };

        //2. 用 SDK 自动生成 EIP-712 域 + 类型 + values
        const { domain, types, values } = AllowanceTransfer.getPermitData(
            permitSingle,
            _permit2,
            chainId
        );
        console.log('wallet::: ', wallet);

        //3. 让钱包签名
        const signature = await wallet.signTypedData({
            domain,
            types,
            primaryType: 'PermitSingle',
            message: values
        });
        console.log('signature::: ', signature);

        return { permitSingle, signature, allowanceTuple };
    }
    return { executeSwapWithFee, getPathBytes, tokenApproveHandler }
}

function truncateToThreeDecimalPlaces(num: bigint): bigint {
    const divisor = 10n ** 9n; // 10^(18-3)
    return (num / divisor) * divisor;
}
